module.exports = __webpack_public_path__ + "assets/img/thumb-The-Onset-Website.3169ba03.jpg";